import { UserFragment } from 'apps/shared/scripts/graphql';

import { FormValues } from '../components/AccountSettingsForm/types';

const getDefaultValues = (user: UserFragment): FormValues => {
  return {
    email: user.email,
    name: user.name,
  };
};

export default getDefaultValues;
